import { render, staticRenderFns } from "./screening.vue?vue&type=template&id=d55a83f2&scoped=true&"
import script from "./screening.vue?vue&type=script&lang=js&"
export * from "./screening.vue?vue&type=script&lang=js&"
import style0 from "./screening.vue?vue&type=style&index=0&id=d55a83f2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55a83f2",
  null
  
)

export default component.exports